import { createSlice } from '@reduxjs/toolkit';

const initialState = {
//     name: 'テスト',
//     mail: 'test@example.com',
//     telephone: '090-1234-5678',
//     address: '東京都千代田区千代田1-1',
//     memo: '',
//     telephoneRequest: 0,
//     mailRequest: 0
};

const slice = createSlice({
    name: 'authorwill',
    initialState,
    reducers: {
        setName: (state, action) => {
            return Object.assign({}, state, { name: action.payload })
        },
        clearName: state => {
            return Object.assign({}, state, { name: '' })
        },
        setMail: (state, action) => {
            return Object.assign({}, state, { mail: action.payload })
        },
        clearMail: state => {
            return Object.assign({}, state, { mail: '' })
        },
        setTelephone: (state, action) => {
            return Object.assign({}, state, { telephone: action.payload })
        },
        clearTelephone: state => {
            return Object.assign({}, state, { telephone: '' })
        },
        setAddress: (state, action) => {
            return Object.assign({}, state, { address: action.payload })
        },
        clearAddress: state => {
            return Object.assign({}, state, { address: '' })
        },
        setMemo: (state, action) => {
            return Object.assign({}, state, { memo: action.payload })
        },
        clearMemo: state => {
            return Object.assign({}, state, { memo: '' })
        },
        setTelephoneRequest: (state, action) => {
            return Object.assign({}, state, { telephoneRequest: action.payload })
        },
        clearTelephoneRequest: state => {
            return Object.assign({}, state, { telephoneRequest: '' })
        },
        setMailRequest: (state, action) => {
            return Object.assign({}, state, { mailRequest: action.payload })
        },
        clearMailRequest: state => {
            return Object.assign({}, state, { mailRequest: '' })
        },
    }
});


export default slice.reducer;

export const {
    setName,
    clearName,
    setMail,
    clearMail,
    setTelephone,
    clearTelephone,
    setAddress,
    clearAddress,
    setMemo,
    clearMemo,
    setTelephoneRequest,
    clearTelephoneRequest,
    setMailRequest,
    clearMailRequest
} = slice.actions;
